/*
    IMPORTANT: 
    YOU ARE NOT ALLOWED TO REMOVE THIS COMMENT AND NO MODIFICATION TO THE EXISTING CODE SHOULD BE MADE WITHOUT THE CONSENT OF THE AUTHOR
    YOU CAN ADD YOUT CODE AFTER THE COMMENT LINE IN THE CODE BELOW


    DISCLAIMER:
    This code is provided "as is" after proper verifications and reviews to the Development Team. 
    The author to this file shall not be held liable for any damages, including any lost profits or other 
    incidental or consequential damages arising out of or in connection with the use or inability to use this code .
    
    © Copyright [14th Jan 2023] [Haseeb Ahmed Khan] [Valentia Technologies Limited]
*/
import React from 'react'
import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()
export const LoaderContext = React.createContext({ loading: false, setLoading: (loading: boolean) => { }, })


//ADD YOUR CODE BELOW THIS LINE